import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export type FundFormData = {
  name: string
  slug: string
  vintage_year: number | ''
}

type FundFormFieldsProps<T extends FundFormData> = {
  data: T
  errors: Partial<Record<keyof T, string>>
  setData: <K extends keyof T>(key: K, value: T[K]) => void
}

export function FundFormFields<T extends FundFormData>({
  data,
  errors,
  setData,
}: FundFormFieldsProps<T>) {
  const err = (key: keyof T) => errors[key]

  return (
    <Card>
      <CardHeader>
        <CardTitle>Fund</CardTitle>
      </CardHeader>
      <CardContent className="grid gap-5 sm:grid-cols-[1fr_1fr_160px]">
        <div className="space-y-1.5">
          <Label htmlFor="name">Name</Label>
          <Input
            id="name"
            value={data.name}
            autoFocus
            onChange={(e) => setData('name' as keyof T, e.target.value as T[keyof T])}
          />
          {err('name' as keyof T) && (
            <p className="text-xs text-destructive">{err('name' as keyof T)}</p>
          )}
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="slug">Slug</Label>
          <Input
            id="slug"
            value={data.slug}
            placeholder="Leave blank to auto-generate"
            onChange={(e) => setData('slug' as keyof T, e.target.value as T[keyof T])}
          />
          {err('slug' as keyof T) && (
            <p className="text-xs text-destructive">{err('slug' as keyof T)}</p>
          )}
        </div>

        <div className="space-y-1.5">
          <Label htmlFor="vintage_year">Vintage year</Label>
          <Input
            id="vintage_year"
            type="number"
            value={data.vintage_year}
            onChange={(e) => {
              const v = e.target.value
              setData(
                'vintage_year' as keyof T,
                (v === '' ? '' : Number(v)) as T[keyof T],
              )
            }}
          />
          {err('vintage_year' as keyof T) && (
            <p className="text-xs text-destructive">{err('vintage_year' as keyof T)}</p>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
